import identityResultError from "./identityResultError";

export default class authModel {
    constructor(data: any) {
        Object.assign(this, data);
    }

    public token: string = "";

    public login: string = "";

    public id: string = "";

    public succeeded: boolean = false;

    public errors: identityResultError[] = [];

    public redirectPage: string = "";

    public getDescriptions() {
        let message = '';
        this.errors.forEach(error => {
            message += error.description + '\n';
        });
        return message;
    }
}